export default "__VITE_ASSET__Dk7Tv9KP__"